//import logo from './logo.svg';
import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

//import Scss
import "./assets/scss/themes.scss";

//import Routes
import Routes from "./routes";

function App() {
  return (
    <React.Fragment>
      <Routes />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        limit={3}
      />
    </React.Fragment>
  );
}

export default App;
